import React from "react";
import { Avatar } from "@material-ui/core";

const LazyAvatar = ({ src, alt, fallback, className }) => {
  return (
    <Avatar className={className}>
      {src ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onError={(e) => {
            e.target.onerror = null;
            e.target.style.display = "none";
          }}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        fallback
      )}
    </Avatar>
  );
};

export default LazyAvatar;
